export default "__VITE_ASSET__bc41f858__"